import UIInputPriceKRW from "components/application/input/UIInputPriceKRW";
import UIButton from "components/buttons/UIButton";
import UICheckbox from "components/checkbox/UICheckbox";
import UICheckboxes from "components/checkbox/UICheckboxes";
import UIDatePicker from "components/datepicker";
import UIDatePicker2 from "components/datepicker/UIDatePicker2";
import UIDateTimeIndicator from "components/atoms/datetime/UIDateTimeIndicator";
import UIInputMask from "components/input/UIInputMask";
import UILabelLink from "components/atoms/label/UILabelLink";
import UIRadio from "components/radios/UIRadio";
import UIRadios from "components/radios/UIRadios";
import UISelect from "components/selectbox/UISelect";
import UITextArea from "components/atoms/textarea/UITextArea";
import FaUIPopupOpen from "components/molecules/commPopupOpen/FaUIPopupOpen";
import UIPopupOpen from "components/molecules/commPopupOpen/UIPopupOpen";
import UIDataTable from "components/datatable/UIDataTable";
import UIFileDownload from "components/file/UIFileDownload";
import UIFileUpload from "components/file/UIFileUpload";
import UIInputSearch from "components/molecules/inputsearch/UIInputSearch";
import UIInputSearch_v2 from "components/molecules/inputsearch/UIInputSearch_v2";
import UIInputSearchHidden from "components/molecules/inputsearch/UIInputSearchHidden";
import UIPaginationBar from "components/pagination/UIPaginationBar";
import UIInputTitleGroup from "components/molecules/title/UIInputTitleGroup";
import UIJsTree from "components/molecules/tree/UIJsTree";
import UISunEditor from "components/wysiwygeditor/UISunEditor";
import FileDownload from "components/raonkupload/UIRaonKFileDownload"
import FileUpload from "components/raonkupload/UIRaonKFileUpload"
import OZHViewer from "components/report/OZHViewer";
import IBSheet from "components/ibsheet/IBSheet";
import UIInputNumber from "components/atoms/input/UIInputNumber";
import input from "./input/input";
import inputPW from "./input/inputPW";
import inputFile from "./input/inputFile";
import inputClear from "./input/inputClear";

export default {
    If: (props: { test:boolean; children:any; }) => props.test && props.children,
    Button: UIButton,
    LabelLink: UILabelLink,
    Input: input,
    InputPW: inputPW,
    InputFile: inputFile,
    InputClear: inputClear,
    InputMask: UIInputMask,
    InputNumber: UIInputNumber,
    TextArea: UITextArea,
    Checkbox: UICheckbox,
    Checkboxes: UICheckboxes,
    Select: UISelect,
    Radios: UIRadios,
    Radio: UIRadio,
    DatePicker: UIDatePicker,
    DatePicker2: UIDatePicker2,
    DateTimeIndicator: UIDateTimeIndicator,
    InputTitleGroup: UIInputTitleGroup,
    InputSearch: UIInputSearch,
    InputSearchPortal: UIInputSearch_v2,
    InputSearchHidden: UIInputSearchHidden,
    DataTable: UIDataTable,
    FileDownloadSimpleMode: UIFileDownload,
    FileUploadSimpleMode: UIFileUpload,
    PaginationBar: UIPaginationBar,
    JsTree: UIJsTree,
    InputPriceKRW: UIInputPriceKRW,
    SunEditor: UISunEditor,
    PopupOpen: UIPopupOpen,
    FaPopupOpen: FaUIPopupOpen,
    FileDownload: FileDownload,
    FileUpload: FileUpload,
    ReportViewer: OZHViewer,
    IBSheet: IBSheet
}

